import { Toaster, toast } from 'sonner'

// TIC-branded Toaster component — add once in App.tsx
export function TICToaster() {
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          fontFamily: 'Outfit, sans-serif',
          borderRadius: '0.75rem',
          border: '1px solid var(--color-border)',
          boxShadow: 'var(--shadow-card)',
        },
        classNames: {
          success: 'bg-card text-text-primary border-success/20',
          error: 'bg-card text-text-primary border-danger/20',
          warning: 'bg-card text-text-primary border-warning/20',
          info: 'bg-card text-text-primary border-accent/20',
        },
      }}
      richColors
      closeButton
    />
  )
}

// Re-export toast for convenience
export { toast }
